import { z } from 'zod';

export const invoiceDetailSearchSchema = z.object({
  viewAttachmentId: z.uuid().optional().catch(undefined),
});
